import { UniButton } from '@/design-system/components/buttons';
import { H6, TextBody, TextCaption, TextTitle } from '@/design-system/components/typography';
import { SxProp, View, useDripsyTheme, styled } from 'dripsy';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/design-system/components/icons/Icon';
import { Row } from '@/design-system/components/layout';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { ChangeATMPINStackParamList } from './type';
import { PageHeaderModalNative } from '../page/PageHeaderModalNative';
import moment from 'moment-timezone';

export interface ChangeATMPINProps {
  onClose: () => void;
  data: any;
  account: string;
  tab?: number;
  returnData?: any;
}

export const ChangeATMPINNativeTwoScreen: React.FC<ChangeATMPINProps> = (props) => {
  const { onClose, data, account, tab, returnData } = props;
  const { t } = useTranslation('account-management');
  const {
    topHeader,
    body,
    horizontalWrapper,
    textLabel,
    textDebitAmount,
    textTitle,
    textAtmPin,
    btn,
    textHeaderTitle,
    textHeaderSubTitle,
    timeView,
    refView,
    modal
  } = sxStyles;

  const showPassword = (atmPin: string) => {
    return `${atmPin.substring(0, 1)}****${atmPin.substring(atmPin.length - 1)}`;
  };

  const { theme } = useDripsyTheme();

  const navigation = useNavigation<NativeStackNavigationProp<ChangeATMPINStackParamList>>();

  const [instructionTime, setInstructionTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));

  return (
    <View sx={{ height: '100%', backgroundColor: '$white' }}>
      <PageHeaderModalNative>
        <Row sx={{ justifyContent: 'center', alignItems: 'center', px: '$4', mt: '$5', mb: '$4' }}>
          <View sx={{ textAlign: 'center' }}>
            <TextTitle bold sx={{ color: theme?.colors?.$white as string }}>
              {t('card-account-management::card-details.text--change-atm-pin')}
            </TextTitle>
          </View>
        </Row>
      </PageHeaderModalNative>
      <View sx={modal}>
        <View sx={topHeader}>
          <Icon name="checkCircleBlue" height={108} width={108} />
          <H6 bold sx={textHeaderTitle}>
            {t('card-account-management::change-atm-pin.title--change-atm-pin-placed')}
          </H6>
          <TextCaption sx={textHeaderSubTitle}>{t('card-account-management::change-atm-pin.text--created-new-pin')}</TextCaption>
        </View>
        <View sx={body}>
          <TextCaption sx={textTitle} semiBold>
            {t('card-account-management::change-atm-pin.text--new-atm-pin')}
          </TextCaption>
          <H6 sx={textAtmPin}>{showPassword(data.pin)}</H6>
          <View
            sx={{
              ...horizontalWrapper,
              ...timeView
            }}>
            <TextBody sx={textLabel}>{t('card-account-management::lock-card.text--instruction-time')}</TextBody>
            <TextBody sx={textDebitAmount}>{returnData?.instructionTime || instructionTime || '-'}</TextBody>
          </View>
          {/* <View
            sx={{
              ...horizontalWrapper,
              ...refView
            }}>
            <TextBody sx={textLabel}>{t('card-account-management::lock-card.text--ref-id')}</TextBody>
            <TextBody sx={textDebitAmount}>{returnData?.refId || '-'}</TextBody>
          </View> */}
          <UniButton
            sx={btn}
            labelSx={{ color: '$balck' }}
            label={t('card-account-management::general.button--close')}
            onPress={() => navigation.getParent()?.goBack()}
          />
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  modal: {
    padding: '$5'
  },
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    background: 'primaryDefault'
  },
  body: {
    py: 28
  },
  horizontalWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textLabel: {
    color: '$textSecondary'
  },
  textDebitAmount: {
    mb: '$1',
    color: '$textPrimary'
  },
  textTitle: {
    marginBottom: 4,
    color: '$textSecondary'
  },
  textAtmPin: {
    fontWeight: 'bolder',
    color: '$textThemeSecondary'
  },
  btn: {
    height: 44,
    width: '92%',
    position: 'fixed',
    left: 0,
    bottom: 0,
    marginX: 15,
    marginBottom: 30
  },
  textHeaderTitle: {
    mb: '$2',
    textAlign: 'center'
  },
  textHeaderSubTitle: {
    color: '$textPrimary'
  },
  timeView: {
    mb: '$3',
    mt: '$5'
  },
  refView: {
    mb: '$10'
  }
};
